/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type ChfarExerciseSliceState = {
  contractId: string | undefined;
};

export const initialState: ChfarExerciseSliceState = {
  contractId: undefined,
};

const chfarExerciseSlice = createSlice({
  name: "chfarExercise",
  initialState,
  reducers: {
    setChfarExerciseContractId(
      exerciseState,
      action: PayloadAction<ChfarExerciseSliceState["contractId"]>
    ) {
      if (action.payload) {
        exerciseState.contractId = action.payload;
      }
    },
  },
});

export const { setChfarExerciseContractId } = chfarExerciseSlice.actions;

export default chfarExerciseSlice.reducer;
